// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prefix-input[data-v-37a73bd0]{position:relative}.prefix-input .prefix[data-v-37a73bd0]{position:absolute;left:12px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);color:#888;font-size:14px;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
